import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import no from "../lang/no.json";
import en from "../lang/en.json";

const savedLang = localStorage.getItem("language") || "no";

i18n
  .use(initReactI18next)
  .init({
    resources: {
      no: { translation: no },
      en: { translation: en },
    },
    lng: savedLang,
    fallbackLng: "no",
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
